import React from 'react';
import * as css from 'styles'
import { connect } from 'react-redux';
import styled from 'react-emotion'

import View from 'components/View/View';
import Text from 'components/Text/Text';
import FadeIn from '../components/Animated/FadeIn';
import Loading from '../components/Loading/Loading'
import Meta from '../components/Meta/Meta'

import titleFromSlug from 'utils/titleFromSlug';

const PageText = styled(Text)({
  fontSize: '1.2em', //css.font.l,
  lineHeight: '1.3em',
  letterSpacing: '0.025em',

  [css.breakpoint.m_down]: {
    fontSize: '1.2em',
    lineHeight: '1.3em',
  },
  
  '& a':{
    textDecoration: 'underline',
  },
})

const NotFound = ({ content, status, slug }) => {

  const page = (content) ? content[0] : null
  const acf = (page && page.acf) ? page.acf : null
  const metaDescription = acf ? acf.meta_description : null;

  window.scrollTo(0, 0)

  return (page) ? (
    <View padding="0 0 4em 0" style={{maxWidth: '725px', margin: '0 auto'}}>
      <Meta title="404" />

      <Loading status={status} height="70vh" nospinner>
      <FadeIn>

        <PageText>
          Page not found.
        </PageText>

      </FadeIn>
      </Loading>
    </View>
  ) : null
};

const mapState = state => ({
  slug: state.location.payload.id,
  content: state.page.data,
  status: state.page.status,
})

export default connect(mapState)(NotFound);




// WEBPACK FOOTER //
// ./src/containers/NotFound.js